/**
 * Blokuje kontextové menu (pravé tlačítko) na celém eshopu.
 *
 * POZOR: tohle není ochrana obsahu. Obchází se přes devtools, Ctrl+U,
 * uložení stránky nebo vypnutí JavaScriptu. Kdo chce fotky stáhnout,
 * stáhne je. Smysl to má jen jako drobná bariéra proti náhodnému
 * kopírování.
 *
 * Ve formulářových polích menu ZÁMĚRNĚ necháváme, jinak by zákazník
 * nemohl vložit e-mail nebo adresu ze schránky.
 */
(() => {
  const ALLOW = 'input, textarea, select, [contenteditable="true"], [contenteditable=""]';

  document.addEventListener(
    'contextmenu',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest(ALLOW)) return;
      event.preventDefault();
    },
    { capture: true }
  );

  // Přetažení obrázku na plochu je druhá nejčastější cesta ke stažení.
  document.addEventListener(
    'dragstart',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (target?.tagName === 'IMG' || target?.tagName === 'PICTURE') event.preventDefault();
    },
    { capture: true }
  );
})();
